import { createContext, useContext } from 'react';
import { useRealtimeSpamShiftManager, RealtimeSpamShiftManagerOptions } from '../lib/supabase/spam-shifts/realtimeSpamShiftManager';

interface RealtimeSpamShiftContextType {
  isConnected: boolean;
}

const RealtimeSpamShiftContext = createContext<RealtimeSpamShiftContextType | undefined>(undefined);

interface RealtimeSpamShiftProviderProps extends RealtimeSpamShiftManagerOptions {
  children: React.ReactNode;
}

export function RealtimeSpamShiftProvider({ children, ...options }: RealtimeSpamShiftProviderProps) {
  const { isConnected } = useRealtimeSpamShiftManager(options);

  return (
    <RealtimeSpamShiftContext.Provider value={{ isConnected }}>
      {children}
    </RealtimeSpamShiftContext.Provider>
  );
}

export function useSupabaseSpamShiftRealtime() {
  const context = useContext(RealtimeSpamShiftContext);
  if (context === undefined) {
    throw new Error('useSupabaseSpamShiftRealtime must be used within a RealtimeSpamShiftProvider');
  }
  return context;
}